import { createSelector } from '@reduxjs/toolkit';
import { getFromImmutableState } from 'src/utils/immutableUtils';

const _modifierSelector = (state) => state.get('modifier');
export const modifierSelector = getFromImmutableState(_modifierSelector);

export const modifierBannerSelector = createSelector(
  [modifierSelector],
  (modifier) => modifier.banner,
);

export const modifierStylesSelector = createSelector(
  [modifierSelector],
  (modifier) => modifier.styles,
);
